module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley"
  }, [_c('div', {
    staticClass: "frontmatter TableOfContents exclude-auto page-open-auto",
    attrs: {
      "id": "TableOfContents1"
    }
  }, [_c('div', {
    staticClass: "title-block exclude-auto",
    attrs: {
      "id": "title-block2"
    }
  }, [_c('h1', {
    attrs: {
      "id": "h13"
    }
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('div', {
    staticClass: "named-lists toc-lists exclude-auto",
    attrs: {
      "id": "toc-lists1"
    }
  }, [_c('div', {
    staticClass: "list-named list-toc exclude-auto",
    attrs: {
      "id": "list-toc1"
    }
  }, [_c('ol', {
    attrs: {
      "id": "ol1"
    }
  }, [_c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781783780853_booktitlepage#BookTitlePage1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/9781783780853_chapter_01#Chapter1"
    }
  }, [_vm._v("I’m Jack")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-fm",
    attrs: {
      "id": "toc-fm1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781783780853_copyrightinserted#h15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dd9a6480","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781783780853_tableofcontents.vue
// module id = 63
// module chunks = 0